module.exports = __webpack_public_path__ + "static/img/company-component-cove-5-2.ba8c4d9a.jpg";